var isIndex = {};
export {
  isIndex as __exports
};
//# sourceMappingURL=isIndex.js.map
